import BaseService from "./geral/BaseService";
import { observable } from "mobx";

const base = "MeuTecon";

export default class MeuTeconService extends BaseService{

    constructor(props){
        super(props)
    }

    Listar = () => {
        return super.httpGet(`/${base}/Listar`);
    }
    
    Salvar = (param) => {
        return super.httpPost(`/${base}/Salvar`, param);
    }
    
    ListarAgendamentosPrevistos = (categoria="") => {
        return super.httpGet(`/${base}/ListarAgendPrevistos?categoria=${categoria}`);
    }
    
    ListarAgendamentoServicoPrevistos = (categoria="") => {
        return super.httpGet(`/${base}/ListarAgendServPrevistos?categoria=${categoria}`);
    }
    ListarContainerPatio = (categoria="") => {
        return super.httpGet(`/${base}/ListarCntrPatio?categoria=${categoria}`);
    }
    ListarDescargasPrevistas = (categoria="") => {
        return super.httpGet(`/${base}/ListarDescargasPrevistas?categoria=${categoria}`);
    }
    ListarFaturas = (categoria="") => {
        return super.httpGet(`/${base}/ListarFaturas?categoria=${categoria}`);
    }
    ListarDashboard = (parcId=null, estabId=null) => {
        return super.httpGet(`/${base}/ListarDashboard?parcid=${parcId}&estabid=${estabId}`);
    }
    ListarEmpresasPorUsuario = (parcId=null, estabId=null) => {
        return super.httpGet(`/${base}/ListarEmpresasPorUsuario?parcid=${parcId}&estabid=${estabId}`);
    }

}


// WEBPACK FOOTER //
// ./src/services/MeuTeconService.js